import { Component, inject, Input, OnDestroy } from '@angular/core';
import { DismissedPopupKeywords, LocalStorage } from '@isophi/core-legacy';

import { PopupService } from '../../services/popup.service';

@Component({
  selector: 'app-demo-popup',
  templateUrl: './demo-popup.component.html',
  styleUrls: ['./demo-popup.component.scss'],
  standalone: false,
})
export class DemoPopupComponent implements OnDestroy {
  private readonly popupService = inject(PopupService);

  private readonly localStorage = new LocalStorage();

  @Input() popupKey: DismissedPopupKeywords;
  @Input() localKey: string;

  dontShowAgain = false;

  onDontShowAgainChange(checked: boolean): void {
    this.dontShowAgain = checked;
    if (checked) {
      this.localStorage.setItem(this.localKey, 'true', false);
    } else {
      this.localStorage.removeItem(this.localKey);
    }
  }

  close(): void {
    this.popupService.closePopup(this.popupKey);
  }

  ngOnDestroy(): void {
    this.popupService.closePopup(this.popupKey, true);
  }
}
